import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js' 
import '../../assets/scripts/number.js'

// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s >$(".section1").offset().top - $("header").height()  && istrue) {
    $(".timer").each(count);
    function count(a) {
        var b = $(this);
        a = $.extend({},
        a || {},
        b.data("countToOptions") || {});
        b.countTo(a)
    };
    istrue = false;
}


$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s >$(".section1").offset().top - $("header").height()  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };  
    
})

var swiper = new Swiper(".section4 .mySwiper", {
    slidesPerView: 3,
    direction: 'vertical',

});
var swiper2 = new Swiper(".section4 .mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
    navigation: {
        nextEl: ".section4 .swiper-button-next",
        prevEl: ".section4 .swiper-button-prev",
    },
});

var leaders = new Swiper(".section5 .swiper", {
    slidesPerView: 3,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
	},
	speed:800,
    pagination: {
        el: ".section5 .swiper-pagination",
    },
    grid: {
        rows: 2,
        fill: 'column'
    },
  spaceBetween: 0,
  breakpoints: {
    // 屏幕宽度小于 600px 时，展示 1 列
    320: {
      slidesPerView: 2,
      grid: {
        rows: 1,
        fill: 'row'
      },
    },
    // 屏幕宽度小于 1024px 时，展示 2 列
    1024: {
      slidesPerView: 2,
      grid: {
        rows: 2,
        fill: 'row'
      },
    },
    // 屏幕宽度大于 1024px 时，展示 5 列
    1025: {
      slidesPerView: 3,
      grid: {
        rows: 2,
        fill: 'row'
      },
    },
  },
});


var swiper = new Swiper('.section6 .swiper', {
    centeredSlides: true,
    loop: true,
    navigation: {
        nextEl: ".section6 .swiper-button-next",
        prevEl: ".section6 .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 2.075,
        spaceBetween: 130,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 2.075,
        spaceBetween: 80,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        spaceBetween: 0,
      }
    } 

});

var swiper3 = new Swiper(".section8 .mySwiper", {
    spaceBetween: '1.3%',
    slidesPerView: 4,
    speed:4000,//匀速时间
    loop:true,
    autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        pauseOnMouseEnter: true, 
    },
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: '1.3%',
            slidesPerView: 4,
        },
        768: {  //当屏幕宽度小于等于768
            spaceBetween: '1%',
            slidesPerView: 3,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 1.5,
            spaceBetween: 10,
        }
    }
});


$(document).ready(function() {
  // 获取所有的 li
  var allItems = $('#itemList li');
  // 总数量
  var totalCount = allItems.length;
  // 当前显示到第几个
  var currentIndex = 0;
  // 每次加载的数量
  var step = 4;
  // 默认显示的数量
  var defaultShow = 8;
  
  // 初始化：先显示前6个
  function initDisplay() {
    // 先隐藏所有
    allItems.hide();
    // 显示前6个
    allItems.slice(0, defaultShow).show();
    currentIndex = defaultShow;
    
    // 如果总数量小于等于默认显示数量，直接隐藏按钮
    if (totalCount <= defaultShow) {
      $('#loadMoreBtn').hide();
    }
  }
  
  // 调用初始化
  initDisplay();
  
  // 点击加载更多按钮
  $('#loadMoreBtn').on('click', function() {
    // 计算这次要显示到第几个
    var nextIndex = Math.min(currentIndex + step, totalCount);
    
    // 显示从 currentIndex 到 nextIndex 的 li
    allItems.slice(currentIndex, nextIndex).fadeIn();
    
    // 更新当前索引
    currentIndex = nextIndex;
    
    // 如果已经全部显示，隐藏按钮
    if (currentIndex >= totalCount) {
      $(this).hide();
    }
  });
});

$(".section10 ul li").eq(0).addClass('active');
$(".section10 ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".text").slideToggle();
})